import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-form-text',
  templateUrl: './form-text.component.html',
  styleUrls: ['./form-text.component.sass'],
})
export class FormTextComponent {
  @Input() text: string;
  @Input() style: any = {};
}
